export default "__VITE_ASSET___E3iRuO$__"